var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfCircleX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.75,
    height: 13.75,
    viewBox: "0 0 13.75 13.75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/circle-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M12.5 6.87501C12.5 3.76839 9.9816 1.25 6.87499 1.25C3.7684 1.25 1.25 3.76839 1.25 6.87501C1.25 9.98162 3.7684 12.5 6.87499 12.5C9.9816 12.5 12.5 9.98162 12.5 6.87501ZM8.30807 4.5581C8.5522 4.31402 8.94779 4.31402 9.19185 4.5581C9.43598 4.80218 9.43598 5.19781 9.19185 5.44189L7.75878 6.87501L9.19185 8.30808C9.43598 8.55215 9.43598 8.94781 9.19185 9.19187C8.94779 9.43593 8.5522 9.43593 8.30807 9.19187L6.87499 7.7588L5.44189 9.19187C5.19781 9.43593 4.80218 9.43593 4.5581 9.19187C4.31403 8.94781 4.31403 8.55215 4.5581 8.30808L5.99121 6.87501L4.5581 5.44189C4.31403 5.19781 4.31403 4.80218 4.5581 4.5581C4.80218 4.31402 5.19781 4.31402 5.44189 4.5581L6.87499 5.99122L8.30807 4.5581ZM13.75 6.87501C13.75 10.672 10.6719 13.75 6.87499 13.75C3.07804 13.75 0 10.672 0 6.87501C0 3.07804 3.07804 0 6.87499 0C10.6719 0 13.75 3.07804 13.75 6.87501Z",
    fill: "#6A7282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfCircleX);
export default __webpack_public_path__ + "static/media/cf-circle-x.c1a06e95fec9f5b2d28fdcf7533aab9b.svg";
export { ForwardRef as ReactComponent };